import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { UrlParamsValues } from './change-url.model';

import { ItxObservabilityCommands } from '@frontend/libs/itx-observability-core';

@Injectable()
export class ChangeUrlService {
    public product$: Observable<any>;

    public category$: Observable<any>;

    /** si el usuario presiona el boton back en el browser no hace falta reecribir el url desde Angular */
    private readonly pressBackBroserButton = false;

    private urlParamsValues: UrlParamsValues = {
        baseUrl: null,
    };

    constructor(
        private readonly router: Router
    ) {

    }

    /**
     * sobre escribe el URL de las vistas productos y/o categorias
     * siempre que el usuario no presione los botones back/foward del browser
     * cuando esto sucede el mismo broser se encarga de actualizar el URL
     * @param path
     */
    public setPageUrl(path: string) {
        // DEUDA TECNICA (la aplicación tiene un sistema de navegación por Effects)
        this.router.navigateByUrl(path);
    }

    /** actualiza el url y/o mantiene los parametros del mismo  */
    public urlKeepParams(urlParamsValues?: UrlParamsValues): void {
        if (urlParamsValues) {
            this.urlParamsValues = urlParamsValues;
        }
        if (this.containEncodedComponent(this.urlParamsValues.locationPath)) {
            this.urlParamsValues.locationPath = encodeURI(urlParamsValues.locationPath);
        }

        const url = this.urlParamsValues.locationPath;
        // biome-ignore lint/nursery/useTopLevelRegex: <explanation>
        const urlSeo = /.*-n(\d{1,8})/.exec(url);
        // extrae todos los parametos del url y los transforma en JSON
        const result: any = {};
        // eslint-disable-next-line deprecation/deprecation
        const query = this.urlParamsValues.params.substr(1);
        // biome-ignore lint/complexity/noForEach: <explanation>
        query.split('&').forEach((part) => {
            const item = part.split('=');
            result[item[0]] = decodeURIComponent(item[1]);
        });

        if (urlSeo && result.celement) {
            // si en el objesto JSON de los parametros viene el
            // celement lo elimino porque es el de la categoria anterior
            // biome-ignore lint/performance/noDelete: <explanation>
            delete result.celement;
            // la key "urlParamsValues.locationPath" puede contener el celement nuevo
            let resultParams = Object.keys(result)

                .map((key) => `${key}=${result[key]}`)
                .join('&');

            // si vienen mas parametros ademas del parametro celement y los concateno
            if (resultParams.length !== 0) {
                resultParams = `&${resultParams}`;
            } else {
                resultParams = '';
            }
            this.setPageUrl(`${url}${resultParams}`);
        } else {
            // si en el objesto JSON de los parametros viene el
            // celement lo elimino porque es el de la categoria anterior
            // Pueden existir urls normales en paises con url pantalla si no han definido la urlSeo
            if (result.celement) {
                // biome-ignore lint/performance/noDelete: <explanation>
                delete result.celement;
            }
            /** actualiza el url y/o mantiene los parametros del mismo de las paginas normales  */
            const urlParams = this.urlParamsValues.params ? `${this.urlParamsValues.params}` : '';
            const path = `${url}${urlParams}`;

            this.setPageUrl(path);
        }
    }

    private containEncodedComponent(url: string): boolean {
        try {
            // verifica si el url esta malformado
            // ....women/collection/knitwear/100%/....
            return decodeURI(url) !== decodeURIComponent(url);
        } catch (error) {
            ItxObservabilityCommands.sendObservabilityLog(error, 'ChangeUrlService containEncodedComponent');
            // copia el url del browser
            return true;
        }
    }
}
